<div class="modal-gs p-3 d-flex flex-column gap-3">
  <header class="d-flex justify-content-between align-items-center">
    <h4 class="modal-title fs-5 pull-left">
      {{ "VEHICLE_USAGES.EDIT_MODAL.TITLE" | translate }}
    </h4>
    <button
      type="button"
      class="btn-close pull-right"
      aria-label="Close"
      (click)="bsModalRef.hide()"
    ></button>
  </header>

  <div class="modal-gs-body">
    <form class="d-flex flex-column gap-3" [formGroup]="form">
      <div class="form-group">
        <label for="startMileage" class="form-label">{{
          "VEHICLE_USAGES.EDIT_MODAL.START_MILEAGE" | translate
        }}</label>
        <div class="input-group">
          <input
            type="number"
            class="form-control"
            formControlName="startMileage"
            id="startMileage"
          />
          <span class="input-group-text">Km</span>
        </div>
      </div>

      <div class="form-group">
        <label for="endMileage" class="form-label">{{
          "VEHICLE_USAGES.EDIT_MODAL.END_MILEAGE" | translate
        }}</label>
        <div class="input-group">
          <input
            type="number"
            class="form-control"
            formControlName="endMileage"
            id="endMileage"
            placeholder="{{
              'VEHICLE_USAGES.EDIT_MODAL.INSERT_KM' | translate
            }}"
          />
          <span class="input-group-text">Km</span>
        </div>
      </div>

      <div class="alert alert-warning" *ngIf="incompatibleMileage">
        {{ "VEHICLE_USAGES.EDIT_MODAL.INCOMPATIBLE_MILEAGE" | translate }}
      </div>
    </form>
  </div>

  <footer class="d-flex gap-2 align-items-center justify-content-center">
    <button type="button" class="btn-gs-secondary" (click)="bsModalRef.hide()">
      {{ "VEHICLE_USAGES.EDIT_MODAL.CANCEL" | translate }}
    </button>
    <button
      type="button"
      class="btn-gs-primary"
      (click)="saveMileage()"
      [disabled]="form.invalid || incompatibleMileage"
    >
      {{ "VEHICLE_USAGES.EDIT_MODAL.SAVE" | translate }}
    </button>
  </footer>
</div>
